import useDrawActivityTransformer from 'interactionModel/transform/useDrawActivityTransformer'
import { useTranslation } from 'react-i18n-lite'
import { InteractionModel, Step } from 'types/shared'
import { getInteractionSavePayload } from './interactionModel'
import api from './api'
import { useCallback } from 'react'

type SaveInteractionParams = {
  shownSteps?: Step[]
  interactionModel: InteractionModel
  draftUuid?: string
  showLoading?: boolean
  activate?: boolean
}

export default function useSaveInteraction() {
  const { language } = useTranslation()

  const draw = useDrawActivityTransformer()

  const saveInteraction = useCallback(
    async ({
      shownSteps,
      interactionModel,
      draftUuid,
      showLoading = true,
      activate = false
    }: SaveInteractionParams) => {
      const transformers = { draw }

      const body = await getInteractionSavePayload({
        shownSteps,
        interactionModel,
        language,
        transformers,
        draftUuid,
        activate
      })

      const endpoint = draftUuid
        ? api.patchSaveInteraction
        : api.postSaveInteraction

      return await endpoint(body, showLoading)
    },
    [language, draw]
  )

  const createInteraction = useCallback(
    async (args: SaveInteractionParams) => {
      return saveInteraction(args) as ReturnType<typeof api.postSaveInteraction>
    },
    [saveInteraction]
  )

  const updateInteraction = useCallback(
    async (args: SaveInteractionParams) => {
      return saveInteraction(args) as ReturnType<
        typeof api.patchSaveInteraction
      >
    },
    [saveInteraction]
  )

  return { createInteraction, updateInteraction }
}
